export const namespaced = true;

export const state = {
  notifications: [],
  google: null,
  geocoder: null,
  map: null,
  markers: []
};

export const mutations = {};

export const actions = {};
